import React, { useEffect, useState } from 'react'
import { api } from '../../app/Api/ApiSlice'
import { toast } from 'react-toastify'
import { useParams } from 'react-router-dom'
import SuggestionMessage from '../../components/SuggestionMessage'
import InfiniteScroll from 'react-infinite-scroll-component'
import Loader from '../../components/Loader'

const Suggestions = () => {
    const [suggestions, setSuggestions] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [page, setPage] = useState(1)
    const [hasMore,setHasMore] = useState(false)

    const { organization } = useParams()

    useEffect(() => {
        const getSuggestions = async () => {
            try {
                setIsLoading(true)
                const response = await api.get(`/${organization}/suggestions`, { params: { page } })
                if (response) {
                    setIsLoading(false)
                    setSuggestions(response.data)
                    setHasMore(response.data ===20)
                }
            } catch (error) {
                setIsLoading(false)
                toast.error(error.response.data.message)
            } finally { setIsLoading(false) }
        }

        getSuggestions()
    }, [page])

    const handleRefresh = async()=>{}
    return (
        <div>
            <div className="org-feed-content">
                {suggestions && suggestions.length > 0 ? (
                    <InfiniteScroll
                        dataLength={suggestions.length}
                        next={() => setPage((prev) => prev + 1)}
                        hasMore={hasMore}
                        refreshFunction={handleRefresh}
                    >
                        {suggestions.map((sugg) => {
                            return (
                                <div key={sugg._id} className="home-feed-post">
                                    <SuggestionMessage sugg={sugg} />
                                </div>
                            );
                        })}
                    </InfiniteScroll>
                ) : (
                    !isLoading && <p className="not-found-msg">no suggestion box messages available`</p>
                )}
                {isLoading && <Loader />}
            </div>
        </div>
    )
}

export default Suggestions